import React, { Component } from 'react';
import { Form, message, Select } from 'antd';

import { queryAccountList } from '@api/core/user';

const { Option } = Select;
const FormItem = Form.Item;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadUsers();
  }

  onChange = (value, selectedOptions) => {
    this.props.onChange(value, selectedOptions);
  };

  /**
   * 获取用户列表
   */
  loadUsers = () => {
    queryAccountList().then(res => {
      if (res.statusCode === 200) {
        this.setState({ users: res.data });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { users } = this.state;
    const { form, field, ItemLayout, data } = this.props;

    return (
      <FormItem label={field.fieldName} {...ItemLayout}>
        {form.getFieldDecorator(field.field, {
          rules: [{ required: field.isRequire, message: `请选择${field.fieldName}!` }],
          initialValue: data ? data[field.field] : '',
        })(
          <Select
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onChange={this.onChange}
          >
            {users.map((item, index) => {
              return (
                <Option key={item.uuid} value={item.uuid}>
                  {item.name}
                </Option>
              );
            })}
          </Select>,
        )}
      </FormItem>
    );
  }
}
export default Index;



// WEBPACK FOOTER //
// ./src/components/comm/SelectUser.js